import React from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';

const { func, string } = propTypes;

function TextField (props) {
	const textClassNames = classnames({
		'form-group': true,
		'form-error': props.formError
	});

	return (
		<div className={textClassNames}>
			{props.label && <span className='lss-form-label' htmlFor={props.name}>{props.label}<br /></span>}
			<input
				type={props.type || 'text'}
				className='form-control'
				placeholder={props.placeholder}
				id={props.name}
				name={props.name}
				value={props.value}
				onChange={props.onChange}
				onBlur={props.onBlur}
			/>
			{props.formError && <span className='error-message'>{props.formError}</span>}
		</div>
	);
}

TextField.propTypes = {
	label: string,
	type: string,
	name: string.isRequired,
	value: string.isRequired,
	placeholder: string,
	formError: string,
	onChange: func,
	onBlur: func
};

export default TextField;
